import { useState, useEffect } from "react";
import useWindowSize from "hooks/useWindowSize.jsx";
import { MdMenuOpen } from "react-icons/md";
import { BiUser } from "react-icons/bi";
import { FiMessageSquare } from "react-icons/fi";
import { ImFileText } from "react-icons/im";
import { FiSettings } from "react-icons/fi";
import styles from "../profile/profile.module.css";
import { RiUserSettingsLine } from "react-icons/ri";
import { NavLink } from "react-router-dom";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import GRC from "assets/images/photo_2022-01-26_11-07-06.png";
import logo from "assets/images/oil/logo2.png";
export default function AdminSidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const { width } = useWindowSize();
  useEffect(() => {
    if (width && width > 992 && isOpen === false) {
      setIsOpen(true);
    }
    if (width && width < 992 && isOpen === true) {
      setIsOpen(false);
    }
  }, [width]);

  return (
    <>
      {width && width < 992 && (
        <button
          style={{
            position: "fixed",
            zIndex: "10",
            top: "-15px",
            backgroundColor: "#ccc",
          }}
          className="btn btn-mobile-menu mt-4 "
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <MdMenuOpen></MdMenuOpen>
        </button>
      )}

      {isOpen && (
        <div
          className={` d-block pb-5 ${
            width && width < 992 && "mobile-sidebar"
          } ${styles.sidebarr}`}
          style={{
            width: "250px",
            position: "sticky",
            top: "0",
            height: "auto",
            backgroundColor: "#203B8C",
            zIndex: "2",
          }}
        >
          <ul
            className={`menu1 nav nav-pills flex-column mb-sm-auto mb-0 align-items-center justify-content-around px-2 ${styles.ulProfile} `}
            id="menu"
          >
            <img
              src={logo}
              alt=""
              style={{
                width: "80px",
                borderRadius: "50%",
                height: "80px",
                overflow: "hidden",
                marginTop: "40px",
              }}
            />
            <NavLink to="/admin-panel/dashboard">
              <div
                className={`d-flex mt-4 text-light d-flex justify-content-evenly align-items-center  ${styles.sidebarLink}`}
              >
                <BiUser />
                <p className="mt-2">داشبورد</p>
              </div>
            </NavLink>
            <NavLink to="/admin-panel/orders">
              <div
                className={`d-flex mt-4 text-light d-flex justify-content-evenly align-items-center ${styles.sidebarLink}`}
              >
                <ImFileText />
                <p className="mt-2">سفارشات</p>
              </div>
            </NavLink>

            <NavLink to="/admin-panel/financial">
              <div
                className={`d-flex mt-4 text-light d-flex justify-content-evenly align-items-center ${styles.sidebarLink}`}
              >
                <FaRegMoneyBillAlt />
                <p className="mt-2">امور مالی</p>
              </div>
            </NavLink>

            <NavLink to="/admin-panel/user_management">
              <div
                className={`d-flex mt-4 text-light d-flex justify-content-evenly align-items-center ${styles.sidebarLink}`}
                style={{
                  marginRight: "30px",
                  paddingRight: "13px",
                  paddingLeft: "15px",
                  width: "max-content",
                }}
              >
                <RiUserSettingsLine />
                <p className="mt-2 ms-2">مدیریت کاربران</p>
              </div>
            </NavLink>
          </ul>
        </div>
      )}
    </>
  );
}
